import { render, staticRenderFns } from "./RevisionType.vue?vue&type=template&id=16e5784f&"
import script from "./RevisionType.vue?vue&type=script&lang=js&"
export * from "./RevisionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports